import React from 'react';
import logo from './logo.svg';
import './App.css';
import DailyLog from './Components/DailyLog';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConfigureStore } from './redux/ConfigureStore';
import Home from './Components/HomeComponent';

//console.log('testxxx');
const store = ConfigureStore();

function App() {
  return (
    <Provider store={store}>
    <BrowserRouter>
    <div className="App">
          <Home />
    </div>
    </BrowserRouter>
    </Provider>
    
    
  );
}

export default App;
